import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

const Button = React.forwardRef(({ 
  className, 
  variant = "default", 
  size = "default", 
  loading = false,
  children, 
  ...props 
}, ref) => {
  const variants = {
    default: "bg-gradient-to-r from-brand-ocean to-brand-lavender text-white hover:from-brand-indigo hover:to-brand-ocean focus:ring-brand-ocean shadow-lg hover:shadow-xl",
    destructive: "bg-gradient-to-r from-brand-pink to-red-600 text-white hover:from-red-600 hover:to-red-700 focus:ring-brand-pink shadow-lg hover:shadow-xl",
    outline: "border-2 border-brand-ocean/30 bg-brand-linen text-brand-indigo hover:bg-brand-ocean/10 hover:border-brand-ocean focus:ring-brand-ocean shadow-md hover:shadow-lg",
    secondary: "bg-gradient-to-r from-brand-linen to-white text-brand-indigo hover:from-brand-ocean/10 hover:to-brand-lavender/10 focus:ring-brand-ocean shadow-md hover:shadow-lg",
    ghost: "text-brand-indigo hover:bg-gradient-to-r hover:from-brand-ocean/10 hover:to-brand-lavender/10 focus:ring-brand-ocean hover:text-brand-ocean",
    link: "text-transparent bg-clip-text bg-gradient-to-r from-brand-ocean to-brand-lavender underline-offset-4 hover:underline focus:ring-brand-ocean",
    success: "bg-gradient-to-r from-emerald-500 to-teal-600 text-white hover:from-emerald-600 hover:to-teal-700 focus:ring-emerald-500 shadow-lg hover:shadow-xl",
    warning: "bg-gradient-to-r from-amber-500 to-orange-500 text-white hover:from-amber-600 hover:to-orange-600 focus:ring-amber-500 shadow-lg hover:shadow-xl"
  };

  const sizes = {
    default: "h-10 px-4 py-2",
    sm: "h-9 rounded-md px-3",
    lg: "h-11 rounded-md px-8",
    icon: "h-10 w-10"
  };

  return (
    <motion.button
      whileHover={{ scale: 1.02, y: -2 }}
      whileTap={{ scale: 0.98 }}
      className={cn(
        "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
        variants[variant],
        sizes[size],
        className
      )}
      ref={ref}
      disabled={loading}
      {...props}
    >
      {loading && (
        <svg className="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      {children}
    </motion.button>
  );
});

Button.displayName = "Button";

export { Button };